import { QRCodeSVG as QRCodeSVGPrimitive } from 'qrcode.react';

export type QRCodeProps = Omit<React.ComponentProps<typeof QRCodeSVGPrimitive>, 'value'> & {
    value?: string | null;
};

export function QRCodeSVG(props: QRCodeProps) {
    const {
        value,
        size = 128,
        fgColor = '#000000',
        bgColor = '#ffffff',
        level = 'L',
        marginSize = 4,
        ...restProps
    } = props;

    if (!value) {
        return null;
    }

    return (
        <QRCodeSVGPrimitive
            value={value}
            size={size}
            fgColor={fgColor}
            bgColor={bgColor}
            level={level}
            marginSize={marginSize}
            {...restProps}
        />
    );
}
